import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useTheme } from "@mui/material/styles";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";
import { CircleArrowUpIcon, ClockIcon } from "../../../../assets/icons";
import { EmployeeExpenseReportsSummaryDTO } from "../../../../models/employee-expense-reports-summary/employee-expense-reports-summary-dto";

const MyTravelAndExpensePendingApprovalsLink = ({
  customSummary,
  loading,
}: {
  customSummary: EmployeeExpenseReportsSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.my_travel_and_expenses.pending";
  const { t } = useTranslation();

  const theme = useTheme();
  return (
    <CircleAndIconContainer
      title={`${t(`${tRP}.title`)}`}
      mainInfo={customSummary?.pendingExpenseReports?.toString() ?? "0"}
      description={`${t(`${tRP}.reports`)}`}
      Icon={CircleArrowUpIcon}
      IconStyle={{
        color: theme.palette.success.main,
        width: "78%",
        height: "78%",
      }}
      titleStyle={{
        width: "min-content",
      }}
      loading={loading}
    />
  );
};
export default MyTravelAndExpensePendingApprovalsLink;
